import React, { Component } from 'react'
import { WizardContext } from 'components/masters'

function decorator() {
  return ComposedComponent => {
    class WithWizardContext extends Component {
      render() {
        return (
          <WizardContext.Consumer>
            {context => (
              <ComposedComponent
                {...context}
                {...this.props}
              />
            )}
          </WizardContext.Consumer>
        )
      }
    }

    return WithWizardContext
  }
}

export default decorator
